// extracted by mini-css-extract-plugin
export default {"wrap":"t3-z","errorMsg":"u3-z","suggestedAddresses":"v3-z","suggestedAddressesMsg":"w3-z"};